import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../packages/react/src/drafts/TabPanels/TabPanels.docs.json';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {TabPanels} from '@primer/react/drafts'
`}</code></pre>
    <p><strong parentName="p">{`Attention:`}</strong>{` Make sure to properly label your `}<inlineCode parentName="p">{`TabPanels`}</inlineCode>{` with an `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to provide context about the subject of your `}<inlineCode parentName="p">{`TabPanels`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`TabPanels.Tab`}</inlineCode>{` elements are wired up to their `}<inlineCode parentName="p">{`TabPanels.Panel`}</inlineCode>{` elements based on the index order that they exist in the document.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<TabPanels aria-label="Select a tab" id="tab-panels" selectedTabIndex={0}>
  <TabPanels.Tab>Tab 1</TabPanels.Tab>
  <TabPanels.Tab>Tab 2</TabPanels.Tab>
  <TabPanels.Tab>Tab 3</TabPanels.Tab>
  <TabPanels.Panel>Panel 1</TabPanels.Panel>
  <TabPanels.Panel>Panel 2</TabPanels.Panel>
  <TabPanels.Panel>Panel 3</TabPanels.Panel>
</TabPanels>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      